// extracted by mini-css-extract-plugin
export default {"placeOrderForm":"PlaceOrder_placeOrderForm__yHrE7"};